module.exports = __webpack_public_path__ + "img/address_icon@3x.4c73c801.png";